import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import DialogMediaPlayer from '../../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { ReactPlayerProps } from 'react-player';
import usePractitionerControlsContext from '../../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { VideoUploadStyle } from './VideoUploadStyle';
import DefaultVideo from '../../../../../../../assets/no-video.svg';
import { PLayerTriggeredBy } from '../../../../../../../commands/practitioner/enums/PLayerTriggeredBy';
import useUploadContext from '../../../../../../../hooks/useUploadContext/useUploadContext';
import UploadProgress from '../../../../../../UI/UploadProgress/UploadProgress';

interface VideoUploadProps {
  className?: string;
  index: number;
  value: number;
}

const VideoUpload = (props: VideoUploadProps) => {
  const { practitionerMediaURI, isMediaLoaded } = usePractitionerControlsContext();
  const { isLoading } = useUploadContext();
  const { videoTabContainer } = VideoUploadStyle;
  const { index, value } = props;

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: practitionerMediaURI,
    width: '100%',
    height: '100%',
    config,
    controls: false,
  };

  return (
    <>
      {index === value && (
        <Box sx={videoTabContainer} role="tabpanel">
          <>
            {isLoading ? (
              <UploadProgress />
            ) : (
              <Box className={'video-container'}>
                {!!practitionerMediaURI && isMediaLoaded ? (
                  <DialogMediaPlayer
                    key={practitionerMediaURI}
                    ReactPlayerProps={reactPlayerPreview}
                    ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
                  />
                ) : (
                  <Box className="video-default">
                    <img className={'img'} src={DefaultVideo} alt="blanc-img" />
                  </Box>
                )}
              </Box>
            )}
          </>
        </Box>
      )}
    </>
  );
};

export default VideoUpload;
